module.exports = __webpack_public_path__ + "img/ground.da92f34d.png";